import {
  type AccessTokenClaims,
  FLEET_PORTAL_ROLES,
  type FleetPortalRole,
  type FleetWebUser,
  WEB_MODULE_PERMISSIONS,
  type WebModule,
} from '@_shared/types'
import { decodeJwt } from '@autoplan/common'

export function canAccessWebModule(user: FleetWebUser, webModule: WebModule): boolean {
  const allowedRoles = WEB_MODULE_PERMISSIONS[webModule]

  const hasAllowedRoles = allowedRoles?.length > 0
  if (!hasAllowedRoles) return false

  const userRoles = extractRoles(user)
  return userRoles.length > 0 && userRoles.some((role) => allowedRoles.includes(role))
}

function extractRoles(user: FleetWebUser): FleetPortalRole[] {
  if (!user) return []

  const { access_token } = user
  if (!access_token) return []

  const groupIds = decodeJwt<AccessTokenClaims>(access_token)?.groupIds
  if (!Array.isArray(groupIds)) return []

  return groupIds.filter(isFleetPortalRole)
}

function isFleetPortalRole(value: unknown): value is FleetPortalRole {
  return typeof value === 'string' && Object.values<string>(FLEET_PORTAL_ROLES).includes(value)
}
